import React, { useState } from "react";
import styles from "./DeleteProfile.module.css";
import DeletePopup from "./DeletePopup/DeletePopup";


const DeleteProfile = ({ onCancel }) => {
  const [popupOpen, setPopupOpen] = useState(false);

  const [agreed1, setAgreed1] = useState(false);
  const [agreed2, setAgreed2] = useState(false);

  const allAgreed = agreed1 && agreed2;

  return (
    <div>
      <h2 className={styles.sectionTitle}>회원탈퇴</h2>
      <div className={styles.withdrawalNotice}>
        <h3>탈퇴 전 꼭 확인해 주세요!</h3>
        <ul>
          <li>
            <strong>탈퇴 시 계정 정보 및 이용 기록은 모두 삭제됩니다.</strong>
            <span>
              회원 정보, 이용 내역, 적립금, 쿠폰, 포인트 등은{" "}
              <text style={{ color: "#F83B6F" }}>복구가 불가능</text>합니다.
            </span>
          </li>
          <li>
            <strong>
              일부 데이터는 법령에 따라 일정 기간 보관될 수 있습니다.
            </strong>
            <span>
              전자상거래 등에서의 소비자 보호에 관한 법률 등에 의거한 기록은
              일정 기간 보관됩니다.
            </span>
          </li>
          <li>
            <strong>
              탈퇴 후 동일한 이메일/휴대폰 번호로 재가입이 일정 기간 제한될 수
              있습니다.
            </strong>
            <span>악용 방지를 위해 일정 기간 재가입이 제한될 수 있어요.</span>
          </li>
          <li>
            <strong>
              진행 중인 서비스가 있다면 탈퇴가 제한될 수 있습니다.
            </strong>
            <span>(예: 결제 진행 중, 환불 대기 등)</span>
          </li>
          <li>
            <strong>작성하신 게시글/댓글은 삭제되지 않을 수 있습니다.</strong>
            <span>
              커뮤니티형 서비스의 경우, 게시글이나 댓글은 계정 정보 삭제 후에도
              남을 수 있어요.
            </span>
            <br />
            <span>삭제를 원하시는 경우 탈퇴 전에 직접 삭제해 주세요.</span>
          </li>
          <li>
            <strong>탈퇴 후에는 동일 계정으로 복구가 불가능합니다.</strong>
            <span>계정 탈퇴는 최종 결정이므로, 신중하게 선택해 주세요.</span>
          </li>
        </ul>
      </div>

      <div className={styles.finalWarningContainer}>
        <div className={styles.finalWarning}>
          <input
            type="checkbox"
            id="agree1"
            checked={agreed1}
            onChange={(e) => setAgreed1(e.target.checked)}
          />
          <label htmlFor="agree1">
            위 탈퇴 유의사항을 모두 확인했으며, 탈퇴에 동의합니다.
            <span className={styles.requiredText}>(필수)</span>
          </label>
        </div>
        <div className={styles.finalWarning}>
          <input
            type="checkbox"
            id="agree2"
            checked={agreed2}
            onChange={(e) => setAgreed2(e.target.checked)}
          />
          <label htmlFor="agree2">
            탈퇴 시 모든 회원 정보 및 서비스 이용 내역이 삭제되며, 복구가
            불가능함을 확인하였습니다.
            <span className={styles.requiredText}>(필수)</span>
          </label>
        </div>
      </div>

      <div className={styles.formActions}>
        <button className={styles.secondaryButton} onClick={onCancel}>
          취소
        </button>
        <button className={styles.primaryButtonDanger} onClick={allAgreed ? () => setPopupOpen(!popupOpen) : null} disabled={!allAgreed}>
          회원탈퇴
        </button>
      </div>

      {popupOpen &&
        <DeletePopup onClose={() => setPopupOpen(false)}/>
      }
    </div>
  );
};

export default DeleteProfile;
